import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './assets/css/styles.css'
import './assets/css/colors.css'
import authPlugin from './plugins/auth'

import $ from 'jquery'

// Déclaration globale pour jQuery
declare global {
  interface Window {
    $: typeof $
  }
}

window.$ = $

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(authPlugin)
app.mount('#app')
